import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { authHeader, handleResponse } from "../../_helpers";

export const loginUser = createAsyncThunk("user/loginUserStatus", async (jwtToken, { dispatch }) => {
  dispatch(setJWT(jwtToken));
  return dispatch(fetchUser());
});

export const fetchUser = createAsyncThunk("user/fetchUserStatus", async (arg, { getState }) => {
  let jwtToken = getState().user.jwt;

  const requestOptions = { method: "GET", headers: authHeader(jwtToken) };
  let url = new URL("/api/user", process.env.REACT_APP_API_PATH);
  return fetch(url, requestOptions).then(handleResponse);
});

export const userSlice = createSlice({
  name: "user",
  initialState: {
    status: "idle",
    user: {},
    jwt: localStorage.getItem("jwt"),
  },
  reducers: {
    setJWT: (state, action) => {
      state.jwt = action.payload;
    },
    logoutUser: (state) => {
      state.user = {};
      state.jwt = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchUser.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchUser.fulfilled, (state, action) => {
        state.status = "idle";
        state.user = action.payload.user;
      })
      .addCase(fetchUser.rejected, (state, action) => {
        state.status = "idle";
        // FIXME - Reenable these lines
        localStorage.clear("jwt");
        state.jwt = null;
        state.user = {};
      });
  },
});

export const { setJWT, logoutUser } = userSlice.actions;

export const selectUserLoggedIn = (state) => state.user.jwt !== null;
export const selectUser = (state) => state.user.user;
export const selectUserJwt = (state) => state.user.jwt;

export default userSlice.reducer;
